export const PIPELINE_TEMPLATES = {
    simple: {
        id: "simple",
        name: "Simple",
        description: "Scan → Key → Verify → Export. For straightforward documents.",
        steps: [
            { stepType: "scan", label: "Scan / Import", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["*"] },
            { stepType: "key", label: "Key Entry", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "verify", label: "Verify", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "export", label: "Export", isRequired: true, autoAdvanceCondition: { allFieldsVerified: true }, allowedRoles: ["*"] },
            { stepType: "escalation", label: "Escalation", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
        ],
    },
    standard: {
        id: "standard",
        name: "Standard",
        description: "Scan → Classify → Key → Verify → Export. Most common workflow.",
        steps: [
            { stepType: "scan", label: "Scan / Import", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["*"] },
            { stepType: "classify", label: "Classify", isRequired: true, autoAdvanceCondition: { classConfidence: 0.9 }, allowedRoles: ["*"] },
            { stepType: "key", label: "Key Entry", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "verify", label: "Verify", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "export", label: "Export", isRequired: true, autoAdvanceCondition: { allFieldsVerified: true }, allowedRoles: ["*"] },
            { stepType: "escalation", label: "Escalation", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
        ],
    },
    compliance: {
        id: "compliance",
        name: "Compliance",
        description: "Scan → Classify → Key → Verify → QC → Export. Adds QC review step.",
        steps: [
            { stepType: "scan", label: "Scan / Import", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["*"] },
            { stepType: "classify", label: "Classify", isRequired: true, autoAdvanceCondition: { classConfidence: 0.9 }, allowedRoles: ["*"] },
            { stepType: "key", label: "Key Entry", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "verify", label: "Verify", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "qc", label: "Quality Control", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["qc", "supervisor", "admin"] },
            { stepType: "export", label: "Export", isRequired: true, autoAdvanceCondition: { allFieldsVerified: true }, allowedRoles: ["*"] },
            { stepType: "escalation", label: "Escalation", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
        ],
    },
    high_volume: {
        id: "high_volume",
        name: "High Volume",
        description: "Scan → Classify → Key → Verify → Supervisor → Export. For batch processing with supervisor review.",
        steps: [
            { stepType: "scan", label: "Scan / Import", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["*"] },
            { stepType: "classify", label: "Classify", isRequired: false, autoAdvanceCondition: { classConfidence: 0.85 }, allowedRoles: ["*"] },
            { stepType: "key", label: "Key Entry", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "verify", label: "Verify", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "supervisor", label: "Supervisor Review", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
            { stepType: "export", label: "Export", isRequired: true, autoAdvanceCondition: { allFieldsVerified: true }, allowedRoles: ["*"] },
            { stepType: "escalation", label: "Escalation", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
        ],
    },
    remittance: {
        id: "remittance",
        name: "Remittance (combined)",
        description: "Scan → Classify → Remittance → Export. Key + balance in one station visit.",
        surface: "remittance",
        steps: [
            { stepType: "scan", label: "Scan / Import", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["*"] },
            { stepType: "classify", label: "Classify", isRequired: true, autoAdvanceCondition: { classConfidence: 0.9 }, allowedRoles: ["*"] },
            { stepType: "remittance", label: "Remittance", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "export", label: "Export", isRequired: true, autoAdvanceCondition: { allFieldsVerified: true }, allowedRoles: ["*"] },
            { stepType: "escalation", label: "Escalation", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
        ],
    },
    remittance_split: {
        id: "remittance_split",
        name: "Remittance (split)",
        description: "Scan → Classify → Remittance Key → Remittance Balance → Export. Two queues; supports dual-control.",
        surface: "remittance",
        steps: [
            { stepType: "scan", label: "Scan / Import", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["*"] },
            { stepType: "classify", label: "Classify", isRequired: true, autoAdvanceCondition: { classConfidence: 0.9 }, allowedRoles: ["*"] },
            { stepType: "remittance-key", label: "Remittance Key", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "remittance-balance", label: "Remittance Balance", isRequired: true, autoAdvanceCondition: null, allowedRoles: ["operator", "admin"] },
            { stepType: "export", label: "Export", isRequired: true, autoAdvanceCondition: { allFieldsVerified: true }, allowedRoles: ["*"] },
            { stepType: "escalation", label: "Escalation", isRequired: false, autoAdvanceCondition: null, allowedRoles: ["supervisor", "admin"] },
        ],
    },
};
//# sourceMappingURL=pipeline-templates.js.map